export const CompanyPropertyEnum = {
    //企业经济性质
    国有企业: 1,
    集体企业: 2,
    有限责任公司: 3,
    股份有限公司: 4,
    私营企业: 5,
    中外合资企业: 6,
    外商投资企业: 7,
};
const companyProperty = {
    1: "国有企业",
    2: "集体企业",
    3: "有限责任公司",
    4: "股份有限公司",
    5: "私营企业",
    6: "中外合资企业",
    7: "外商投资企业",
};

export const CompanyAuditStatusEnum = {
    待审核: 1,
    审核通过: 2,
    已拒绝: 3,
};
const CompanyAuditStatus = {
    1: "待审核",
    2: "审核通过",
    3: "已拒绝",
};
export const CompanyTypeEnum = {
    //企业类型
    主管部门: 4,
    业主: 5,
    建设单位: 1,
    保险公司: 2,
    TIS机构: 3,
    物业公司: 6,
    施工单位: 7,
};
const CompanyType = {
    1: "建设单位",
    2: "保险公司",
    3: "TIS机构",
    4: "主管部门",
    5: "业主",
    6: "物业公司",
    7: "施工单位",
};

export const queryInsureIdiStatusEnum = {
    //意向书状态
    未提交: 1,
    审核中: 2,
    保障中: 3,
    已失效: 4,
    理赔中: 5,
    承保中: 6,
};
const queryInsureIdiStatus = {
    1: "未提交",
    2: "审核中",
    3: "保障中",
    4: "已失效",
    5: "理赔中",
    6: "承保中",
};
export const usertypeEnum = {
    // 用户角色
    建设单位: 1,
    保险公司: 2,
    TIS机构: 3,
    业主: 4,
    物业公司: 5,
    主管部门: 6,
    施工单位: 7,
};
export const expertEnum = {
    // 专家类型
    普通专家: 1,
    资深专家: 2,
    标化评价专家: 3,
    起重设备专家: 4,
};
export const expert = {
    // 专家类型
    1: "普通专家",
    2: "资深专家",
    3: "标化评价专家",
    4: "起重设备专家",
};

export const dangerLevel = {
    // 风险等级
    1: "低风险(4级)",
    2: "一般风险(3级)",
    3: "较大风险(2级)",
    4: "重大风险(1级)",
    5: "无风险",
};

// export const statusVal = { // 风险状态
//     1: "未巡查",
//     2: "待巡查",
//     3: "待整改",
//     4: "待复查",
//     5: "已整改",
//     6: "通过"
// }

export const statusVal = {
    // 风险状态
    1: "巡查中",
    2: "待整改",
    3: "待复查",
    4: "已整改",
    5: "通过",
    6: "待审核",
};

export const riskStatus = {
    // 风险状态
    1: "巡查中",
    2: "待整改",
    3: "待复查",
    4: "已整改",
    5: "已完成",
    6: "已驳回",
    7: "正常",
    8: "待组长审核",
    9: "待专家审核",
};
export const planStatus = {
    //服务任务状态
    1: "待服务",
    2: "服务中",
    3: "已完成",
    4: "待组长审核",
    5: "待专家审核",
    6: "待下发",
    7: "整改中",
    8: "已驳回",
};
export const insureSourceStatus = {
    // 风险状态
    1: "待设置TIS",
    2: "待关联",
    3: "已关联",
};
// 1-未分配 , 2-未服务 , 3-服务中 , 4-已完成
export const warrantyStatus = {
    // 保单状态
    1: "未分配",
    2: "未服务",
    3: "服务中",
    4: "已完成",
    // 5: "承保中",
    // 6: "已失效",
    // 7: "待关联",
};

export const insureStatus = {
    // 保单状态
    1: "未承保",
    2: "承保中",
    3: "已过保",
    4: "已竣工",
    5: "已停工",
};
export const planType = {
    // 服务类型
    1: "现场巡查服务",
    2: "教育培训服务",
    3: "应急演练服务",
    4: "起重机械专项检查",
    5: "技术交底服务",
};
// ;1--- 4-
export const reportStatus = {
    // 服务类型
    1: "待生成",
    2: "生成中",
    3: "已生成",
    4: "生成异常",
};

export const reportFirstFileStatus = {
    // 首次服务报告状态
    0: "未上传",
    1: "超时上传",
    2: "已上传",
};
export const proType = {
    // 服务类型
    1: "房建项目",
    2: "市政项目",
};

export const reportType = {
    // 服务类型
    0: "竣工验收报告",
    1: "服务方案",
    // 2: "安全风险初步评估报告",
    // 3: "安全风险初步评估报告(季报)",
    // 4: "安全风险总体评估报告",
};

export const scoreType = {
    // 服务类型
    0: "不可评价",
    1: "优秀",
    2: "良好",
    3: "合格",
    4: "不合格",
    5: "待评价",
};

// 1-待设置 , 2-服务中 , 3-已完成 , 4-待组长审核 , 5-待专家审核 , 6-待下发 , 7-整改中 , 8-已驳回
const planStatusColorMap = {
    //服务任务状态对应的颜色
    1: "gray",
    2: "orange",
    3: "green",
    4: "pink",
    5: "purple",
    6: "blue",
    7: "lightBlue",
    8: "red",
};
// 1-巡查中 , 2-待整改 , 3-待复查 , 4-已整改 , 5-已完成 , 6-已驳回 , 7-正常 , 8-组长审核 , 9-专家审核
const riskStatusColorMap = {
    //服务任务状态对应的颜色
    1: "orange",
    2: "lightBlue",
    3: "orange",
    4: "blue",
    5: "green",
    6: "red",
    7: "green",
    8: "pink",
    9: "purple",
};

// 1-未导出 , 2-导出中 , 3-待上传 , 4-上传中 , 5-上传失败 , 6-已完成
const exportColorMap = {
    //服务任务状态对应的颜色
    1: "gray",
    2: "orange",
    3: "blue",
    4: "pink",
    5: "red",
    6: "green",
};
// 1-低风险项目 , 2-中风险项目 , 3-高风险项目
const riskTypeMap = {
    //服务任务状态对应的颜色
    0: "无风险项目",
    1: "低风险项目",
    2: "中风险项目",
    3: "高风险项目",
};
// 导出状态1-未导出 , 2-导出中 , 3-待上传 , 4-上传中 , 5-上传失败 , 6-已完成
const exportStatusMap = {
    1: "未导出",
    2: "导出中",
    3: "待上传",
    4: "上传中",
    5: "上传失败",
    6: "已完成",
};
/**
 * @description 用户状态1-正常 , 2-离职 , 3-禁用 , 4-未启用
 */
// 1-低风险项目 , 2-中风险项目 , 3-高风险项目
const userStatusMap = {
    //服务任务状态对应的颜色
    1: "启用",
    2: "离职",
    3: "禁用",
    4: "未启用",
};
/**
 * @description 专业方向
 */
const expertiseMap = Object.freeze({
    1: "交通",
    2: "房建",
    3: "水利",
    4: "起重机械",
    5: "基坑工程",
});
/**
 * @description  职称等级
 */
const jobGradeMap = Object.freeze({
    1: "初级",
    2: "中级",
    3: "高级",
    4: "正高级",
});
/**
 * @description  销项状态 1-已驳回 , 2-审核中 , 3-通过
 */
const closedStatus = Object.freeze({
    1: "已驳回",
    2: "待审核",
    3: "通过",
});
import Vue from "vue";
Vue.prototype.$planStatusColorMap = planStatusColorMap;
Vue.prototype.$riskStatusColorMap = riskStatusColorMap;
Vue.prototype.$exportColorMap = exportColorMap;

Vue.prototype.$getRiskStatus = (row) => {
    let str = riskStatus[row.status];
    if (row.closedTime != "0001-01-01 00:00:00") {
        str = str + "(销项)";
    }
    return str;
};

Vue.filter("getConstants", function (val, key) {
    if (key == "CompanyPropertyEnum") {
        return CompanyProperty[val];
    } else if (key == "CompanyTypeEnum") {
        return CompanyType[val];
    } else if (key == "CompanyAuditStatusEnum") {
        return CompanyAuditStatus[val];
    } else if (key === "queryInsureIdiStatusEnum") {
        return queryInsureIdiStatus[val];
    } else if (key == "expertEnum") {
        return expert[val];
    } else if (key == "dangerLevel") {
        return dangerLevel[val];
    } else if (key == "statusVal") {
        return statusVal[val];
    } else if (key == "insureSourceStatus") {
        return insureSourceStatus[val];
    } else if (key == "warrantyStatus") {
        return warrantyStatus[val];
    } else if (key == "planType") {
        return planType[val];
    } else if (key == "riskStatus") {
        return riskStatus[val];
    } else if (key == "insureStatus") {
        return insureStatus[val];
    } else if (key == "proType") {
        return proType[val];
    } else if (key == "planStatus") {
        return planStatus[val];
    } else if (key == "reportType") {
        return reportType[val];
    } else if (key == "scoreType") {
        return scoreType[val] || "-";
    } else if (key == "reportFirstFileStatus") {
        return reportFirstFileStatus[val] || "-";
    } else if (key == "reportStatus") {
        return reportStatus[val] || "-";
    } else if (key == "riskType") {
        return riskTypeMap[val] || "-";
    } else if (key == "userStatusMap") {
        return userStatusMap[val] || "-";
    } else if (key == "expertiseMap") {
        return expertiseMap[val] || "-";
    } else if (key == "jobGradeMap") {
        return jobGradeMap[val] || "-";
    } else if (key == "closedStatus") {
        return closedStatus[val] || "可销项";
    } else if (key == "exportStatus") {
        return exportStatusMap[val] || "-";
    }
});

export const safeUpfiles = {
    //安责险文件上传类型
    投保企业营业执照副本: 1,
    企业证书: 2,
    建设工程规划许可证: 3,
    立项文件: 4,
    工程建设报建表: 5,
    造价证明文件: 6,
};

// auditType
// AuditEdit(1,"投保人修改"),
// AuditOne(2,"保险公司一审"),
// AuditTis(3,"TIS机构审核"),
// AuditTwo(4,"保险公司二审");

// auditStatus
// NoAudit(1, "未提交"),
// Auditing(2, "审核中"),
// AuditSuccess(3, "审核通过"),
// AuditFail(4, "审核拒绝");

// status
// Uncommitted(1,"未提交"),
// Auditing(2,"审核中"),
// Active(3,"保障中"),
// Claimsing(4,"理赔中"),
// Completed(5,"承保中"),
// Failure(6,"已失效");

export const areaList = [
    {
        label: "椒江区",
        value: "椒江区",
    },
    {
        label: "路桥区",
        value: "路桥区",
    },
    {
        label: "黄岩区",
        value: "黄岩区",
    },
    {
        label: "温岭市",
        value: "温岭市",
    },
    {
        label: "玉环市",
        value: "玉环市",
    },
    {
        label: "仙居县",
        value: "仙居县",
    },
    {
        label: "临海市",
        value: "临海市",
    },
    {
        label: "三门县",
        value: "三门县",
    },
    {
        label: "天台县",
        value: "天台县",
    },
    {
        label: "国际部",
        value: "国际部",
    },
];
